import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Col } from 'antd';
import _ from 'underscore';
import Loader from '../../components/Loader';
import EditorElement from '../../components/EditorElement';
import { getAllCategoryElements } from '../../utils/services/elementAPI';
import { TabMenuHeaderContainer, TabMenuHeader, TabMenuItemContainer, TabMenuItemDetails } from '../SidebarMenu/styles';

const CATEGORY_ELEMENT_KEY = 'masterElements';

const ElementCard = ({ elementObj, addElementOnclick }) => {
  let categoryElement = {
      id: elementObj.id,
      name: elementObj.name,
      thumbnail: elementObj.thumbnail,
      type: 'plain',
      elementDetails: elementObj.element,
      tags: elementObj.tags,
      elementType: "masterElement",
      referenced: false,
    };
    if (elementObj.element) {
      if (!_.isArray(elementObj.element)) {
        if (elementObj.element.blockElements) {
          categoryElement.type = 'colored';
        } else {
          const type = elementObj.element.type || elementObj.element.tagName;
          if (['barcode', 'image', 'table', 'textbox', 'checkboxgroup', 'radiobuttongroup', 'signature'].includes(type)) {
            categoryElement.type = 'colored';
          }
        }
      } else {
        categoryElement.type = 'colored';
      }
    }
    return (
      <TabMenuItemDetails key={categoryElement.id} type="element">
        <EditorElement
          element={categoryElement}
          clickElement={addElementOnclick}
          toggleDragging={() => {}}
          pageSettings={{}}
          setIsDragAndDropped={() => {}}
          docElementTab={true}
        />
      </TabMenuItemDetails>
    );
}

const CreativeElementsTabDetails = ({ t, addElementOnclick }) => {
  const [ loading, setLoading ] = useState(true);
  const [ response, setResponse ] = useState([]);
  // const [ selectedCategory, setSelectedCategory ] = useState(undefined); // TODO : Integrate search by name, category and see all options

  useEffect(() => {
    setLoading(true);
    getAllCategoryElements(false, false, undefined, true).then(response => {
      if (response && response.data) {
        setResponse(response.data);
      }
      setLoading(false);
    })
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
        {response.map(category => (
          category[CATEGORY_ELEMENT_KEY] &&
          <TabMenuHeaderContainer key={category.categpryId}>
            <Col>
              <TabMenuHeader className='categoryName'><h2>{category.categoryName}</h2></TabMenuHeader>
            </Col>
            {category[CATEGORY_ELEMENT_KEY].length ? (
              <TabMenuItemContainer>
                {category[CATEGORY_ELEMENT_KEY].map((elementObj, index) => {
                    return <ElementCard elementObj={elementObj} addElementOnclick={addElementOnclick} />;
                })}
              </TabMenuItemContainer>
            ) : (
              <div></div>
            )}
          </TabMenuHeaderContainer>
        ))}
    </>
  )
}

export default withTranslation('DESIGN_AREA_ELEMENTS_TAB')(CreativeElementsTabDetails);